
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "../services/firebaseConnection";

export default function Private({ children }) {

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);


    useEffect(() => {

        const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
            setUser(firebaseUser);
            setLoading(false);
        });

        return unsubscribe;

    }, []);

    if(loading) return null;

    if(!user) {
        return <Navigate to="/login" replace />;
    }

    return children;

}
    
